export const getErrorMessage = (error) => {
  return (
    error.response?.data?.message ||
    error.message ||
    "An unexpected error has occurred. Please try again later."
  );
};
